module.exports = __webpack_public_path__ + "static/media/agile.a5c4fdd3.svg";